import { IDs } from '../../../helpers/IDs';

export function getCustomFormEventHandler(entity: string, item: any, data: any): any {
    const config: any = {};
    const events: any = {};
    data = data || {};
    item = item || {};

    switch (entity) {
        case IDs.ENT_ENERGIEDATEN_WASSER:
            events.zaehler_tid = (component: any, callback?:(data: any) => void) => {
                return {
                    onMenuOpen: (params?: any) => {
                        const bundle: any = (params || {}).bundleData;

                        if (Array.isArray(bundle) && !bundle.length && typeof callback === 'function') {
                            callback({ stateComponent: { showDialog: true, zaehlerTid: 0 } });
                        }
                    }
                }
            };
            events.zaehler2_tid = (component: any, callback?:(data: any) => void) => {
                return {
                    onMenuOpen: (params?: any) => {
                        const bundle: any = (params || {}).bundleData;

                        if (Array.isArray(bundle) && !bundle.length && typeof callback === 'function') {
                            callback({ stateComponent: { showDialog: true, zaehlerTid: 0 } });
                        }
                    }
                }
            };
            break;
    }
    Object.keys(events).forEach((key: string) => config[key] = { event_handler: events[key] });

    return config;
}
